import React from "react";
import BaseButton from "./BaseButton";
import { VerticalAlignBottomOutlined } from '@ant-design/icons';

const BaseDownload = (props) => <BaseButton className={ "download-button" } type="primary" { ...props } >{ props.text ? props.text : "Download Sample" } <VerticalAlignBottomOutlined className="download-button-icon" /></BaseButton>

export default BaseDownload;
